import React, { useState } from 'react';
import UserManagement from '../components/Admin/UserManagement';
import BackupManagement from '../components/Admin/BackupManagement';
import Logs from '../components/Admin/Logs';

const Admin = () => {
    const [activeTab, setActiveTab] = useState('users');

    return (
        <div className="page">
            <h2>Административная панель</h2>
            <p>Эта страница доступна только администраторам.</p>

            <div className="modal-tabs">
                <div className="tabs-header">
                    <button
                        className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
                        onClick={() => setActiveTab('users')}
                    >
                        Пользователи
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'backups' ? 'active' : ''}`}
                        onClick={() => setActiveTab('backups')}
                    >
                        Резервные копии
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'logs' ? 'active' : ''}`}
                        onClick={() => setActiveTab('logs')}
                    >
                        Лог
                    </button>
                </div>

                <div className="tab-content">
                    {activeTab === 'users' && (
                        <UserManagement />
                    )}
                    {activeTab === 'backups' && (
                        <BackupManagement />
                    )}
                    {activeTab === 'logs' && (
                        <Logs />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Admin;
